import { type SocketMachineContext } from '../../../network-state-machine-context';
import { type DebounceCompletedEvent } from '../../../network-state-machine-events';

export async function waitingAsync<T extends Pick<SocketMachineContext, 'debounce'>>(
  ctx: T
): Promise<DebounceCompletedEvent> {
  await ctx.debounce.debounceReconnection();

  return {
    type: 'debounceComplete',
  };
}
